if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
          select: "select",
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");
      }

      connectedCallback() {
        this.mainProduct = document.querySelector("product-info[id^='MainProduct']");
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");
        this.mainAddToCart = this.mainProductForm.querySelector(".m-add-to-cart");
        this.mainDynamicCheckout = this.mainProductForm.querySelector(this.selectors.buyNowBtn);
        this.disableSelectedVariantDefault = this.mainProduct.dataset.disableSelectedVariantDefault === "true" || false;
        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.init();
      }

      init() {
        if (!this.mainAddToCart) {
          this.container.style.setProperty("--m-translate-y", 0);
          return;
        }

        this.variantData = this.getVariantData();

        const headerHeight = MinimogSettings.headerHeight || 66;
        const rootMargin = `${headerHeight}px 0px 0px 0px`;

        if ("IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.intersectionRatio !== 1) {
                  this.container.style.setProperty("--m-translate-y", 0);
                } else {
                  this.container.style.setProperty("--m-translate-y", "100%");
                }
                document.documentElement.classList[entry.intersectionRatio !== 1 ? "add" : "remove"]("stick-atc-show");
              });
            },
            { threshold: 1, rootMargin }
          );
        }

        if (this.disableSelectedVariantDefault) {
          this.handleDisableSelectedVariantDefault();
        }

        const { prodTitle, mainImage } = this.domNodes;
        prodTitle.addEventListener("click", () => __scrollToTop());
        mainImage.addEventListener("click", () => __scrollToTop());

        this.handleCustomFields();

        this.setObserveTarget();
        this.syncWithMainProductForm();

        const mql = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
        mql.onchange = this.setStickyAddToCartHeight.bind(this);
        this.setStickyAddToCartHeight();

        this.domNodes.select.addEventListener("change", (e) => {
          const { target } = e;
          const variantPicker = this.mainProduct.querySelector('variant-picker');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));
          this.currentVariant ? this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings.soldOut) : this.toggleAddButton(true, window.MinimogStrings.unavailable);

          const selectedOption = target.options[target.selectedIndex];
          const selectedOptionIds = selectedOption.dataset.options.split(',').filter(id => id);

          if (variantPicker) {
            selectedOptionIds.forEach((optionId) => {
              const input = variantPicker.querySelector(`[data-option-value-id="${optionId}"]`);
              const { tagName } = input;
              switch (tagName) {
                case "OPTION":
                  const inputParent = input.parentNode; // select tag
                  inputParent.value = input.value;
                  break;
                case "INPUT":
                  input.checked = true;
                  break;
              }
            });
            variantPicker.dispatchEvent(new Event("change"));
          }
        });
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      setObserveTarget() {
        if (this.observer) {
          this.observer.observe(this.mainProductForm);
          this.observeTarget = this.mainProductForm;
        }
      }

      setUnavailable() {
        const productForm = this.querySelector('.m-product-form');
        const addButton = productForm.querySelector('[name="add"]');

        if (addButton) {
          this.toggleAddButton(true, window.MinimogStrings.unavailable);
        }
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('.m-product-form');
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span.m-add-to-cart--text');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.innerHTML = window.MinimogStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      handleDisableSelectedVariantDefault() {
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("variant")) return;

        const canonicalVariantInput = this.querySelector('[data-one-luxury-canonical-sticky-variant-input="true"]');
        if (canonicalVariantInput?.dataset.selectedVariant) {
          canonicalVariantInput.value = canonicalVariantInput.dataset.selectedVariant;
          canonicalVariantInput.setAttribute('value', canonicalVariantInput.dataset.selectedVariant);
          canonicalVariantInput.disabled = false;
          return;
        }

        const pickerFields = this.querySelector('.m-product-option--dropdown-select');
        if (!pickerFields) {
          this.setUnavailable();
          return;
        }
        pickerFields.value = '';
        this.setUnavailable();
      }

      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", this.offsetHeight + "px");
        window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');
        const isCanonicalVariantInput = variantInput?.dataset.oneLuxuryCanonicalStickyVariantInput === 'true';
        const syncVariantInput = (value) => {
          if (!variantInput) return;
          const resolvedValue = value == null ? '' : String(value);
          variantInput.value = resolvedValue;
          if (isCanonicalVariantInput) {
            variantInput.setAttribute('value', resolvedValue);
            variantInput.dataset.selectedVariant = resolvedValue;
            variantInput.disabled = !resolvedValue;
          }
        };

        if (isCanonicalVariantInput && variantInput.dataset.selectedVariant) {
          syncVariantInput(variantInput.dataset.selectedVariant);
        }

        MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, (e) => {
          const isMainProduct = e.data.sectionId === this.mainProduct.dataset.sectionId;
          if (!isMainProduct) return;
          this.currentVariant = e.data.variant;
          if (this.currentVariant) {
            syncVariantInput(e.data.variant.id);
            this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings.soldOut)
          } else {
            syncVariantInput('');
            this.toggleAddButton(true, window.MinimogStrings.unavailable)
          }
        });
      }

      handleCustomFields() {
        if (!this.hasCustomFields) return;

        const { addToCart, buyNowBtn, foxkitBtn } = this.domNodes;

        let hasCustomFieldRequired = false;
        const customFields = document.querySelectorAll(".m-main-product--info .m-product-custom-field");
        let customFieldFirst = customFields[0];
        customFields &&
          customFields.forEach((item) => {
            const field = item.querySelector(".form-field");
            if (field.value == "" && field.hasAttribute("required")) {
              hasCustomFieldRequired = true;
            }
          });

        hasCustomFieldRequired &&
          addToCart.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            __scrollToTop(this.mainProductInfo, () => this.mainAddToCart.click());
          });
        if (buyNowBtn) {
          buyNowBtn.addEventListener(
            "click",
            (e) => {
              const missing = validateForm(this.mainProductInfo);
              if (missing.length > 0) {
                e.preventDefault();
                e.stopPropagation();
                __scrollToTop(this.mainProductInfo, () => this.mainDynamicCheckout.click());
              }
            },
            true
          );
        }
        if (foxkitBtn) {
          foxkitBtn.addEventListener("click", (e) => {
            e.preventDefault();
            __scrollToTop(this.mainProductInfo, () => this.mainAddToCart.click());
          });
        }
      }
    }
  );
}

(() => {
  "use strict";

  if (window.__oneLuxuryCubanStickySelectionSyncInitialized) return;
  window.__oneLuxuryCubanStickySelectionSyncInitialized = true;

  const stickySelector = '.m-sticky-addtocart[data-one-luxury-cuban-sticky-sync="true"]';

  const restoreChooseOptions = (sticky) => {
    const actions = sticky.querySelector(".m-sticky-addtocart--rightblock");
    const staleForm = actions?.querySelector('form[action*="/cart/add"]');
    if (!actions || !staleForm) return;

    sticky.dataset.oneLuxuryStickyMode = "choose_options";
    actions.replaceChildren();

    const href = sticky.dataset.oneLuxuryStickyPickerHref;
    const text = sticky.dataset.oneLuxuryStickySelectOptionsText;
    if (!href || !text) return;

    const link = document.createElement("a");
    link.className = "m-button m-button--primary m:w-full";
    link.href = href;
    link.setAttribute("data-one-luxury-sticky-choose-options", "");
    link.textContent = text;
    actions.append(link);
  };

  const failClosedMainForm = (productInfo) => {
    const variantInput = productInfo?.querySelector?.(
      'form[action*="/cart/add"] [name="id"][data-one-luxury-canonical-variant-input="true"]'
    );
    const form = variantInput?.form;
    if (!form) return;

    // The next server response is authoritative. Until it arrives, prevent the
    // previously resolved exact variant from remaining submittable.
    form.dataset.oneLuxuryPurchasable = "false";
    form.dataset.oneLuxuryCubanSelectionPending = "true";
    variantInput.value = "";
    variantInput.setAttribute("value", "");
    variantInput.dataset.selectedVariant = "";
    variantInput.disabled = true;

    form.querySelectorAll('button[name="add"], [data-add-to-cart]').forEach((button) => {
      button.disabled = true;
      button.setAttribute("aria-disabled", "true");
    });
  };

  document.addEventListener("change", (event) => {
    if (!(event.target instanceof Element)) return;

    const variantPicker = event.target.closest("variant-picker");
    const productInfo = variantPicker?.closest("product-info");
    const sectionId = productInfo?.dataset.sectionId;
    const sticky = sectionId
      ? document.getElementById(`Sticky-Addtocart-${sectionId}`)
      : null;
    if (!sticky?.matches(stickySelector)) return;

    restoreChooseOptions(sticky);
    failClosedMainForm(productInfo);
  }, true);

  const variantChangeEvent = window.MinimogTheme?.pubSubEvents?.variantChange;
  if (window.MinimogEvents?.subscribe && variantChangeEvent) {
    window.MinimogEvents.subscribe(variantChangeEvent, ({ data } = {}) => {
      const sectionId = data?.sectionId;
      if (!sectionId) return;

      const stickyId = `Sticky-Addtocart-${sectionId}`;
      const currentSticky = document.getElementById(stickyId);
      if (!currentSticky?.matches(stickySelector)) return;

      const sourceSticky = data.html?.getElementById?.(stickyId);
      if (sourceSticky?.matches(stickySelector)) {
        currentSticky.replaceWith(sourceSticky);
        return;
      }

      const resolvedVariantId = data.variant?.id == null ? "" : String(data.variant.id);
      const currentVariantId = currentSticky.querySelector(
        '[name="id"][data-one-luxury-canonical-sticky-variant-input="true"]'
      )?.dataset.selectedVariant || "";
      if (resolvedVariantId && currentVariantId === resolvedVariantId) return;

      restoreChooseOptions(currentSticky);
    });
  }

  document.addEventListener("submit", (event) => {
    if (!(event.target instanceof HTMLFormElement)) return;

    if (event.target.dataset?.oneLuxuryCubanSelectionPending === "true") {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    const sticky = event.target.closest(stickySelector);
    const variantInput = event.target.querySelector(
      '[name="id"][data-one-luxury-canonical-sticky-variant-input="true"]'
    );
    const selectedVariantId = variantInput?.dataset.selectedVariant || "";
    if (!sticky || !/^\d+$/.test(selectedVariantId)) return;

    // The server renders this exact-ID form only after the centralized resolver
    // authorizes cart checkout. Re-commit that same ID at submit time because an
    // installed option script can clear hidden input values after section render.
    variantInput.value = selectedVariantId;
    variantInput.setAttribute("value", selectedVariantId);
    variantInput.disabled = false;
  }, true);
})();
